import { ModalSignatureProps, typedMemo } from "src/types";
import { ModalInfo } from "../modal-info/modal-info";
import { useTranslation } from "react-i18next";
import { FailureIcon } from "src/assets";

export const ModalSignature = typedMemo(

 ({onRetry, signInProgressMessage}: ModalSignatureProps) => {

   const { t } = useTranslation() ;

   return (
     <ModalInfo
       visible={true}
       title={t("signStatus.error_title")}
       icon={FailureIcon}
       iconClasses="filter-F34747"
       message={signInProgressMessage}
       confirmText={t("signStatus.error_retry")}
       onConfirm={onRetry}
       onClose={onRetry}
     />
   );
 }
);